import { Link } from 'react-router-dom';

const steps = [
  {
    n: '1',
    title: 'Escolha o plano e monte os apps',
    text: 'Você assina pelo site, no Pix ou no cartão, escolhendo o tamanho da equipe e os apps da sua operação. O plano traz inbox, filas e funil de vendas. Sem fidelidade.',
  },
  {
    n: '2',
    title: 'Conecte o WhatsApp oficial',
    text: 'Você mesmo liga o número numa janela da Meta, em cerca de cinco minutos. A taxa da Meta por mensagem vai direto para a conta da sua empresa, sem markup da Operax.',
  },
  {
    n: '3',
    title: 'Ative mais apps quando precisar',
    text: 'Agenda, estoque, PDV, Pix, nota fiscal, contratos, IA e Hub Comercial entram pelo Portal de Apps, no mesmo login. O preço de cada app aparece antes de confirmar.',
  },
];

/** Como a Operax é contratada: texto simples, é o que assistentes de IA citam ao explicar "como funciona". */
export function HomeHow() {
  return (
    <section className="hx-sec" id="como-funciona">
      <div className="hx-wrap">
        <div className="hx-head rev">
          <span className="hx-label blue">Como funciona</span>
          <h2>Da assinatura ao primeiro atendimento em três passos.</h2>
          <p>
            A Operax é vendida por assinatura mensal, direto no site. Empresas maiores pedem um orçamento sob medida
            em <Link to="/solicitar-orcamento">solicitar orçamento</Link>.
          </p>
        </div>
        <ol className="hx-steps">
          {steps.map((s) => (
            <li key={s.n} className="hx-note rev">
              <span className="hx-stepn">{s.n}</span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </li>
          ))}
        </ol>
        <p className="hx-fine-dark">
          Dúvida de como conectar? Veja o <Link to="/guias/como-conectar-whatsapp-api-oficial">passo a passo da conexão</Link>.
        </p>
      </div>
    </section>
  );
}
